/**
 * 비디오 블록 (P5-④) — BlockNote `video` 블록 렌더/직렬화.
 * { type:"video", props:{ url, previewWidth? }, content:[], children:[] }
 * 리사이즈는 ./controls.js(attachVideoControls)가 처리(.lumir-video-handle). nodownload·우클릭 차단.
 */

import { neutralizeUrl } from "../../utils/url.js";

export function videoBlockToElement(block) {
  if (typeof document === "undefined") throw new Error("videoBlockToElement: DOM 필요");
  const el = document.createElement("div");
  el.className = "block";
  el.dataset.type = "video";
  if (block && block.id != null) el.dataset.id = String(block.id);
  el.__props = block && block.props ? { ...block.props } : {};
  el.__children = block && Array.isArray(block.children) ? block.children : [];

  const props = el.__props;
  const wrap = document.createElement("div");
  wrap.className = "lumir-video";
  wrap.setAttribute("contenteditable", "false");

  if (props.url) {
    const inner = document.createElement("div");
    inner.className = "lumir-video-inner";
    if (props.previewWidth) inner.style.width = props.previewWidth + "px";
    const v = document.createElement("video");
    v.src = neutralizeUrl(props.url);
    v.controls = true;
    v.setAttribute("controlsList", "nodownload");
    v.setAttribute("playsinline", "");
    if (props.previewHeight) v.style.height = props.previewHeight + "px";
    v.addEventListener("contextmenu", (e) => e.preventDefault());
    inner.appendChild(v);
    inner.insertAdjacentHTML("beforeend", '<div class="lumir-video-handle left"></div><div class="lumir-video-handle right"></div><div class="lumir-video-handle bottom"></div>');
    wrap.appendChild(inner);
  } else {
    const ph = document.createElement("div");
    ph.className = "lumir-video-placeholder";
    ph.textContent = "비디오 URL 없음";
    wrap.appendChild(ph);
  }
  el.appendChild(wrap);
  return el;
}

export function videoElementToBlock(el) {
  const block = {};
  if (el.dataset.id != null) block.id = el.dataset.id;
  block.type = "video";
  block.props = el.__props || {};
  // 파일형 블록: blocknote 구조상 content 키 없음(no content)
  block.children = el.__children || [];
  return block;
}
